import React from "react";
import { useDrag } from "react-dnd";

import { IFile } from "../../../../state";
import { DnDItemTypes } from "../../../../pages/manager/UploadStudentRealPhotos/types";
import PhotoImg from "../PhotoImg";

type Props = {
  photo: IFile;
};

export default function UploadedPhotoListItem({ photo }: Props) {
  const [{ isDragging }, drag] = useDrag({
    item: { type: DnDItemTypes.PHOTO, value: photo.id },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return (
    <div ref={drag} style={{ cursor: isDragging ? "grabbing" : "grab" }}>
      <div className="row align-items-center">
        <div className="col-12">
          <PhotoImg src={photo.url} alt={photo.name} />
        </div>
      </div>
    </div>
  );
}
